/** Atlas PM · 项目星图 · 节点悬浮胶囊（设计稿 11：深色胶囊 + 语义色圆点） */

import type { StarLayoutNode } from './layout';
import { colorForState, labelForState } from './layout';

export interface NodeInfoCardProps {
  node: StarLayoutNode;
  x: number;
  y: number;
}

export default function NodeInfoCard({ node, x, y }: NodeInfoCardProps) {
  const progress = node.task?.progressPct ?? 0;
  const overdue = node.task?.overdueDays ?? 0;
  const color = node.isCenter ? '#5EE7FF' : colorForState(node.state);

  return (
    <div className="star-tip star-tip--capsule" style={{ left: x + 16, top: y + 14 }}>
      <span className="star-tip__dot" style={{ background: color }} />
      <span className="star-tip__name">
        {node.isCenter ? '✦ ' : ''}
        {node.name}
      </span>
      {node.isCenter ? (
        <span className="star-tip__sub">项目核心</span>
      ) : (
        <span className="star-tip__sub">
          {labelForState(node.state)} · <b>{progress.toFixed(1)}%</b>
          {overdue > 0 && <span className="star-tip__overdue"> · 逾期 {overdue} 天</span>}
        </span>
      )}
    </div>
  );
}
